<template>
  <div v-wechat-title="$route.meta.title">
    <common-header></common-header>
    <common-nav :locale="locale"></common-nav>
    <div class="new-detail">
      <div class="news-header">
        <div class="txt">{{ detail.title }}</div>
        <div class="time">{{ detail.publishTime }}</div>
      </div>
      <div class="news-content" v-html="detail.content"></div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import CommonHeader from "./components/Common/Header";
import CommonNav from "./components/Common/OtherNav";
import CommonFooter from "./components/Common/Footer";
import CommonBanner from "./components/Common/Banner";
export default {
  components: {
    UAnimateContainer,
    UAnimate,
    CommonNav,
    CommonHeader,
    CommonFooter,
    CommonBanner
  },
  data() {
    return {
      detail: "",
      id: "",

      locale: "zh-cn"
    };
  },
  created() {
    let _router = this.$route;
    this.id = _router.params.id;
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let lang2 = this.locale ? this.locale : "zh-cn";
      this.$axios
        .post(
          "/api/news/detail",
          {
            id: this.id
          },
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          console.log(res);
          if (res.data.errorCode === 0) {
            this.detail = res.data.data.news;
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.news-header {
  margin-top: 100px;
  width: 100%;
  box-sizing: border-box;
  padding: 90px 0 52px;
  background: #f7f8fa;
  padding-left: 20%;
  .txt {
    margin-bottom: 48px;
    color: #333;
    line-height: 1.5;
    font-size: 0.5rem;
    font-weight: bold;
    word-wrap: break-word;
  }
  .time {
    color: #666;
    font-weight: bold;
    font-size: 0.2rem;
  }
}
.news-content {
  width: 60%;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 1rem;
  box-sizing: border-box;
  font-size: 0.3rem;
}
@media screen and (max-width: 750px) {
  .news-header {
    margin-top: 60px;
    width: 100%;
    box-sizing: border-box;
    padding: 35px;
    background: #f7f8fa;
    .txt {
      margin-bottom: 20px;
      color: #333;
      line-height: 1.5;
      font-size: 1.2rem;
      font-weight: bold;
      word-wrap: break-word;
    }
    .time {
      color: #666;
      font-weight: bold;
      font-size: 0.5rem;
    }
  }
  .news-content {
    margin-top: 60px;
    width: 100%;
    box-sizing: border-box;
    padding: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/NewsDetail.vue